import React from 'react';
import { Box, Chip, LinearProgress } from '@mui/material';
import { WalteroCard, WalteroTypography, WalteroDataTable } from '../waltero';

const ApiUsageEndpoints = ({ data, onEndpointClick }) => {
  console.log('📊 ApiUsageEndpoints - data received:', data);

  if (!data) {
    return (
      <Box sx={{ p: 3 }}>
        <WalteroTypography variant="body1" color="textSecondary">
          Loading endpoints data...
        </WalteroTypography>
      </Box>
    );
  }

  // Ensure data is an array
  const endpointsArray = Array.isArray(data) ? data : [];

  const columns = [
    {
      id: 'method',
      label: 'Method',
      width: 80,
      render: (value) => (
        <Chip label={value} size="small" color="primary" />
      )
    },
    {
      id: 'path',
      label: 'Endpoint Path',
      flex: 1,
      render: (value, row) => (
        <WalteroTypography
          variant="body2"
          sx={{ cursor: 'pointer', '&:hover': { color: 'primary.main' } }}
          onClick={() => onEndpointClick(row.endpoint)}
        >
          {value}
        </WalteroTypography>
      )
    },
    {
      id: 'total_calls',
      label: 'Total Calls',
      width: 120,
      align: 'right',
      type: 'number',
      render: (value) => new Intl.NumberFormat().format(value)
    },
    {
      id: 'unique_users',
      label: 'Unique Users',
      width: 120,
      align: 'right',
      type: 'number'
    },
    {
      id: 'success_rate',
      label: 'Success Rate',
      width: 150,
      accessor: (row) => 100 - row.error_rate,
      render: (value, row) => (
        <Box sx={{ width: '100%' }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
            <WalteroTypography variant="caption">{100 - row.error_rate}%</WalteroTypography>
          </Box>
          <LinearProgress
            variant="determinate"
            value={100 - row.error_rate}
            sx={{
              height: 6,
              borderRadius: 3,
              bgcolor: 'grey.200',
              '& .MuiLinearProgress-bar': {
                bgcolor: row.error_rate <= 5 ? 'success.main' : row.error_rate <= 10 ? 'warning.main' : 'error.main'
              }
            }}
          />
        </Box>
      )
    },
    {
      id: 'average_response_time',
      label: 'Avg Response',
      width: 120,
      align: 'right',
      type: 'number',
      render: (value) => `${value}ms`
    },
    {
      id: 'calls_per_user',
      label: 'Calls/User',
      width: 100,
      align: 'right',
      type: 'number'
    }
  ];

  return (
    <Box sx={{ p: 3 }}>
      <WalteroCard>
        <Box sx={{ p: 2 }}>
          <WalteroTypography variant="h6" gutterBottom>
            Endpoint Performance Statistics
          </WalteroTypography>
          <WalteroTypography variant="caption" color="textSecondary" sx={{ display: 'block', mb: 2 }}>
            {endpointsArray.length} endpoints tracked
          </WalteroTypography>
          <WalteroDataTable
            data={endpointsArray}
            columns={columns}
            pagination={{ defaultPageSize: 25 }}
            sortable={true}
            filterable={true}
          />
        </Box>
      </WalteroCard>
    </Box>
  );
};

export default ApiUsageEndpoints;